module.exports = __webpack_public_path__ + "website/img/dl10.4dbfe48c.png";